import React, {useEffect} from 'react';
import type {QuestionComponentProps} from '../../shared/QuestionComponent/QuestionComponent.react';
import {QuestionComponent} from '../../shared/QuestionComponent/QuestionComponent.react';
import {setUpQuestionStore} from 'client/components/QuestionTypes/V2/useQuestionStores';
import InputArea from './InputArea.react';

const OrderingComponent = (props: QuestionComponentProps) => {
  const {activeQuestion, questionState} = props;
  const useStoreHook = setUpQuestionStore<'ordering'>(
    activeQuestion?.getType?.(),
    activeQuestion?.getStoreName?.() || 'ordering' // default to 'ordering' if store name is not provided
  );

  // oxlint-disable-next-line react/hooks -- useStoreHook comes from setUpQuestionStore's registry (cached zustand hook keyed by store name); its identity is stable for a mounted component
  const addQuestionInfo = useStoreHook((state) => state.addQuestionInfo);

  useEffect(() => {
    if (activeQuestion && questionState === 'Dennis') {
      addQuestionInfo(activeQuestion, true);
    }
  }, [activeQuestion, addQuestionInfo, questionState]);

  return (
    <QuestionComponent
      {...props}
      // customExplanation={<PassageCorrectionExplanation question={activeQuestion} />}
      ActiveQuestionInputArea={InputArea}
    />
  );
};

type OrderingQuestionTypeProps = Omit<QuestionComponentProps, 'questionState'>;

const OrderingQuestion = {
  PreGuess: (props: OrderingQuestionTypeProps) => (
    <OrderingComponent {...props} questionState='PreGuess' />
  ),
  PostGuess: (props: OrderingQuestionTypeProps) => (
    <OrderingComponent {...props} questionState='PostGuess' />
  ),
  Dennis: (props: OrderingQuestionTypeProps) => (
    <OrderingComponent {...props} questionState='Dennis' />
  )
};

export {OrderingQuestion};
export default OrderingQuestion;
